module.exports = __webpack_public_path__ + "static/media/features_student.0463792e.png";